// extracted by mini-css-extract-plugin
export var clickThrough = "_ye-2";
export var fallback = "_ye-5";
export var frame = "_ye-3";
export var frameCell = "_ye-1";
export var overlay = "_ye-4";
export var wrapper = "_ye-0";